<script>
  import AppButton from "@components/Button.svelte";
  import DataTableBlack from "@components/DataTableBlack.svelte";
  import Modal from "@components/Modal.svelte";
  import { Button, InfoBlock, TextInput } from "paxray-components-svelte";
  import { fetchWrapper } from "lib/util/fetchWrapper.js";
  import {
    appDisplayName,
    appMatches,
    findCustomMatch,
    findPresetMatch,
    findPresetSuggestions,
  } from "lib/util/restrictionRules.js";

  export let currentStep, stepsCompleted, idproject, firstOpen;

  let explanationModalOpen = false;
  let submitModalOpen = false;
  let blacklistApps = [];
  let newItemModalOpen = false;
  let currentApp = { name: "", appname: "", windowtitleorurl: "", reason: "" };
  let currentDetails = [];
  let currentlistid = 0;
  let currentdisplayid = -1;
  let editId = -1;
  let presetModalOpen = false;
  let presetPagination = { page: 1, pageSize: 10 };
  let presetSearchTerm = "";
  let expandedRowIds = [];
  let showHowto = false;
  let howtoStep = 0;

  const howtoSteps = [
    {
      image: "img/userinput/apps/screen1.png",
      text: "Open the app",
    },
    {
      image: "img/userinput/apps/screen2.png",
      text: "Press Ctrl + Shift + Esc to open Task Manager",
    },
    {
      image: "img/userinput/apps/screen3.png",
      text: "Right click the app and choose Properties",
    },
    {
      image: "img/userinput/apps/screen4.png",
      text: "Copy the file name, e.g. whatsapp.exe",
    },
  ];

  $: isLastHowtoStep = howtoStep === howtoSteps.length - 1;

  function openHowto() {
    howtoStep = 0;
    showHowto = true;
  }

  function nextHowtoStep() {
    if (isLastHowtoStep) showHowto = false;
    else howtoStep += 1;
  }

  function previousHowtoStep() {
    if (howtoStep === 0) showHowto = false;
    else howtoStep -= 1;
  }

  fetchWrapper(`/api/damprojects/getUserLimitations/Blacklist`)
    .then((response) => response.json())
    .then((data) => {
      blacklistApps = normalizeRows(data.desktop);
    });

  function normalizeRows(rows) {
    return (rows || []).map((row) => ({
      ...row,
      user: Array.isArray(row.user) ? row.user : [],
      preset: Array.isArray(row.preset) ? row.preset : [],
    }));
  }

  function addToBlacklist(id = 0) {
    if (!blacklistApps[id]) return;
    newItemModalOpen = true;
    currentlistid = id;
    editId = -1;
    appnameerror = false;
    showHowto = false;
    currentApp = {
      limitationPresetId: blacklistApps[id]["id"],
      editable: true,
      id: blacklistApps[id].user.length,
      name: "",
      appname: "",
      windowtitleorurl: "",
      reason: "",
    };
  }

$: console.log({currentApp})

  let appnameerror = false;

  $: presetMatch = findPresetMatch(
    blacklistApps,
    currentApp.appname,
    appMatches,
  );
  $: customDuplicate = findCustomMatch(
    blacklistApps,
    currentApp.appname,
    appMatches,
    { listId: currentlistid, ruleId: editId },
  );
  $: appSuggestions = findPresetSuggestions(
    blacklistApps,
    currentApp.appname,
    (preset) => preset.appname,
  );

  function applySuggestion(suggestion) {
    currentApp.appname = suggestion.preset.appname;
    currentApp.name = suggestion.preset.name;
  }

  function saveNewApp() {
    appnameerror = !currentApp.appname;
    if (appnameerror || customDuplicate) return;

    currentApp.name = currentApp.name || appDisplayName(currentApp.appname);
    currentApp.windowtitleorurl = currentApp.windowtitleorurl || "";
    currentApp.reason = currentApp.reason || "";

    if (editId == -1) blacklistApps[currentlistid]["user"].push(currentApp);
    else blacklistApps[currentlistid]["user"][editId] = currentApp;
    blacklistApps = blacklistApps;
    newItemModalOpen = false;
    expandedRowIds = ["project-application-exclusions"];
  }

  function editUserApp(listId, id) {
    currentlistid = listId;
    editId = id;
    appnameerror = false;
    showHowto = false;
    currentApp = blacklistApps[currentlistid]["user"][editId];
    newItemModalOpen = true;
  }

  function deleteFromBlackList(list, id) {
    list.splice(id, 1);
    let indexcounter = 0;
    list.forEach((element) => {
      element.id = indexcounter;
      indexcounter++;
    });
    list = list;
    blacklistApps = blacklistApps;
  }

  function submitBlacklist() {
    fetchWrapper(`/api/damprojects/saveUserLimitations/${idproject}/black`, {
      method: "POST",
      body: JSON.stringify(blacklistApps),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status == "success") {
          currentStep = 1;
          stepsCompleted = true;
          submitModalOpen = false;
        }
      });
  }

  $: {
    if (blacklistApps.length > 0 && currentdisplayid >= 0)
      currentDetails = blacklistApps[currentdisplayid]["user"].concat(
        blacklistApps[currentdisplayid]["preset"],
      );
  }

  function includesSearch(value, searchTerm) {
    return String(value || "")
      .toLowerCase()
      .includes(searchTerm);
  }

  $: presetRows = blacklistApps.flatMap((row, sourceIndex) =>
    (row.preset || []).map((preset, presetIndex) => ({
      ...preset,
      id: `${sourceIndex}-${presetIndex}`,
      category: row.name,
    })),
  );
  $: customRows = blacklistApps.flatMap((row, sourceIndex) =>
    (row.user || []).map((rule) => ({
      ...rule,
      id: `${sourceIndex}-${rule.id}`,
      sourceIndex,
      sourceId: rule.id,
    })),
  );
  $: projectRows = [
    {
      id: "project-application-exclusions",
      name: "Custom Application Exclusions",
      description: "Add desktop apps that should be excluded for this project.",
      presets: presetRows.length,
      edit: true,
    },
  ];
  $: presetGroups = blacklistApps.map((row, sourceIndex) => ({
    ...row,
    id: `${sourceIndex}`,
    presetCount: (row.preset || []).length,
    presetRows: (row.preset || []).map((preset, presetIndex) => ({
      ...preset,
      id: `${sourceIndex}-${presetIndex}`,
    })),
  }));
  $: normalizedPresetSearchTerm = presetSearchTerm.trim().toLowerCase();
  $: filteredPresetGroups = presetGroups.filter((group) => {
    if (!normalizedPresetSearchTerm) return true;

    return (
      includesSearch(group.name, normalizedPresetSearchTerm) ||
      includesSearch(group.description, normalizedPresetSearchTerm) ||
      group.presetRows.some((preset) =>
        Object.values(preset).some((value) =>
          includesSearch(value, normalizedPresetSearchTerm),
        ),
      )
    );
  });
</script>

<Modal
  bind:open={submitModalOpen}
  modalHeading="Submit Entries"
  primaryButtonText="Submit Excluded Apps"
  secondaryButtonText="Cancel"
  secondaryButtonAction={() => (submitModalOpen = false)}
  on:open
  on:close={() => (submitModalOpen = false)}
  on:submit={submitBlacklist}
  primaryButtonAction={submitBlacklist}
  actions
  autowidth
>
  <p>Do you want to submit your entries?</p>
  <p>This is a permanent action and cannot be undone.</p>
</Modal>

<Modal
  open={firstOpen || explanationModalOpen}
  modalHeading="First Steps"
  primaryButtonText="Okay"
  preventCloseOnClickOutside
  actions
  primaryButtonAction={() => {
    explanationModalOpen = false;
    firstOpen = false;
  }}
  on:open
  on:close={() => {
    explanationModalOpen = false;
    firstOpen = false;
  }}
  on:submit={() => {
    explanationModalOpen = false;
    firstOpen = false;
  }}
>
  <h5>
    In this example we show you how to add the game "Solitaire" to the blacklist
  </h5>
  <br /><br /><br />
  <video style="width:100%" controls>
    <track kind="captions" /><track />
    <source src="/img/userinput/apps/explanation.mp4" type="video/mp4" />
    Your browser does not support the video tag.
  </video>
</Modal>

<Modal
  bind:open={presetModalOpen}
  modalHeading="Application Presets"
  primaryButtonText="Okay"
  preventCloseOnClickOutside
  noSecondaryButton
  primaryButtonAction={() => (presetModalOpen = false)}
  on:close={() => (presetModalOpen = false)}
  width="auto"
  actions
>
  <DataTableBlack
    expandable
    headers={[
      { key: "name", value: "Name" },
      { key: "description", value: "Description" },
      { key: "presetCount", value: "Presets" },
    ]}
    rows={filteredPresetGroups}
    bind:page={presetPagination.page}
    bind:pageSize={presetPagination.pageSize}
    totalItems={filteredPresetGroups.length}
    pageSizes={[10, 25, 50, 100]}
    searchValue={presetSearchTerm}
    on:search={(e) => {
      presetSearchTerm = e.detail.value;
    }}
    showNewButton={false}
  >
    <svelte:fragment slot="expanded-row" let:row>
      <DataTableBlack
        headers={[
          { key: "name", value: "Name" },
          { key: "appname", value: "Application" },
          { key: "windowtitleorurl", value: "Window title" },
          { key: "reason", value: "Reason" },
        ]}
        rows={row.presetRows}
        showToolbar={false}
        showPagination={false}
      >
        <svelte:fragment slot="cell" let:cell>
          {cell.value || ""}
        </svelte:fragment>
      </DataTableBlack>
    </svelte:fragment>
  </DataTableBlack>
</Modal>

<!-- <div class="information_fields">
  <div class="information_field_top">
    Here, you can limit the initial scope of the paxray sensor by defining
    exclusions for desktop apps.
    <Help20
      style="float:right; cursor:pointer; color:#FF5F1F"
      on:click={() => {
        explanationModalOpen = true;
      }}
    />
  </div>
  <div class="information_field_bottom">
    You will find lists of blacklist presets. You can add more apps quickly with
    a single mouse click. To view the blacklisted apps, click on the arrow to
    expand the list.
    <br />
    <br />
    Click on the respective <span>+</span> to add your own exclusions and follow
    the displayed introductions.
    <br />
    <br />
    Submit your input by clicking on <span>submit</span> in the bottom-right corner
    to proceed to the next step.
  </div>
</div> -->

<DataTableBlack
  expandable
  headers={[
    { key: "name", value: "Name" },
    { key: "description", value: "Description" },
    { key: "presets", value: "Presets" },
    { key: "edit", value: "Actions" },
  ]}
  rows={projectRows}
  bind:expandedRowIds
  showToolbar={false}
  showPagination={false}
>
  <svelte:fragment slot="cell" let:cell let:row>
    {#if cell.key == "edit"}
      <div class="action_cell">
        <AppButton
          variant="secondary"
          size="sm"
          text="Add App"
          on:click={() => addToBlacklist(0)}
        />
      </div>
    {:else if cell.key == "presets"}
      <span data-guide="restrictions-presets">
        <AppButton
          variant="secondary"
          size="sm"
          text="{row.presets} App Presets"
          on:click={() => (presetModalOpen = true)}
        />
      </span>
    {:else}
      {cell.value}
    {/if}
  </svelte:fragment>
  <svelte:fragment slot="expanded-row" let:row>
    <DataTableBlack
      headers={[
        { key: "name", value: "Name" },
        { key: "appname", value: "Application" },
        { key: "windowtitleorurl", value: "Window title" },
        { key: "reason", value: "Reason" },
        { key: "editable", value: "Actions" },
      ]}
      rows={customRows}
      showToolbar={false}
      showPagination={false}
    >
      <svelte:fragment slot="cell" let:cell let:row={innerrow}>
        {#if cell.key == "editable"}
          <div class="action_cell">
            <AppButton
              variant="secondary"
              size="sm"
              text="Edit"
              on:click={() => {
                editUserApp(innerrow.sourceIndex, innerrow.sourceId);
              }}
            />
            <AppButton
              variant="secondary"
              size="sm"
              text="Delete"
              on:click={() => {
                deleteFromBlackList(
                  blacklistApps[innerrow.sourceIndex].user,
                  innerrow.sourceId,
                );
              }}
            />
          </div>
        {:else}
          {cell.value || ""}
        {/if}
      </svelte:fragment>
    </DataTableBlack>
  </svelte:fragment>
</DataTableBlack>

<div class="button_wrapper" data-guide="restrictions-submit">
  <div></div>
  <AppButton
    variant="secondary"
    text="Submit Excluded Apps"
    on:click={() => (submitModalOpen = true)}
  />
</div>

<Modal
  bind:open={newItemModalOpen}
  modalHeading={showHowto ? "How to find the file name" : "Add Application"}
  preventCloseOnClickOutside
  noSecondaryButton
  primaryButtonText={showHowto ? (isLastHowtoStep ? "Got it" : "Next") : "Save"}
  primaryButtonAction={showHowto ? nextHowtoStep : saveNewApp}
  primaryButtonVariant="secondary"
  on:close={() => (newItemModalOpen = false)}
  width="auto"
  actions
  xxl
>
  {#if showHowto}
    <div class="howto">
      <img
        class="howto_image"
        src={howtoSteps[howtoStep].image}
        alt={howtoSteps[howtoStep].text}
      />
      <div class="howto_text">
        <p class="howto_step">Step {howtoStep + 1} of {howtoSteps.length}</p>
        <p>{howtoSteps[howtoStep].text}</p>
      </div>
    </div>
  {:else}
    <div class="blacklist_application_modal">
      <InfoBlock
        type="info"
        heading="Which app?"
        message="This app will be explicitly excluded from all future data collection. Enter its file name or type its name to pick a suggestion."
        showClose={false}
      />

      <div class="input_wrapper">
        <div class="rule_input">
          <div class="rule_input_row">
            <div class="rule_input_field">
              <TextInput
                invalid={(appnameerror && !currentApp.appname) || customDuplicate}
                invalidText={customDuplicate
                  ? "This app is already in your custom rules"
                  : "Please specify an application"}
                labelText="Application Name (required)"
                placeholder="Enter technical app name or search presets, e.g. solitaire.exe"
                description={presetMatch
                  ? `Also covered by the preset list ${presetMatch.group.name}. This rule keeps it excluded even if the preset is disabled.`
                  : null}
                required
                bind:value={currentApp.appname}
              />
            </div>
            <div class="howto_button">
              <Button kind="secondary" on:click={openHowto}>
                How do I find the file name?
              </Button>
            </div>
          </div>
          {#if appSuggestions.length}
            <div class="rule_suggestions">
              {#each appSuggestions as suggestion}
                <AppButton
                  variant="secondary"
                  size="sm"
                  text="{suggestion.preset.name} ({suggestion.group})"
                  on:click={() => applySuggestion(suggestion)}
                />
              {/each}
            </div>
          {/if}
        </div>
        <TextInput
          labelText="Display Name (optional)"
          placeholder="Shown in the rule list, e.g. Solitaire"
          bind:value={currentApp.name}
        />
        <TextInput
          labelText="Window Title (optional)"
          placeholder="Window title displayed, e.g. Solitaire Collection"
          bind:value={currentApp.windowtitleorurl}
        />
        <TextInput
          labelText="Reason (optional)"
          placeholder="Short reason for this rule, e.g. private nature / game"
          bind:value={currentApp.reason}
        />
      </div>
    </div>
  {/if}
  <div slot="left-buttons">
    {#if showHowto}
      <AppButton
        variant="secondary"
        text={howtoStep === 0 ? "Back to form" : "Back"}
        on:click={previousHowtoStep}
      />
    {:else}
      <AppButton
        variant="secondary"
        text="Cancel"
        on:click={() => (newItemModalOpen = false)}
      />
    {/if}
  </div>

  <!-- <div class="button_wrapper">
      <AppButton
        variant="secondary"
        text="Cancel"
        on:click={() => (newItemModalOpen = false)}
      />
      <AppButton variant="secondary" text="Save" on:click={saveNewApp} />
    </div> -->
</Modal>

<style>
  .button_wrapper {
    display: flex;
    justify-content: space-between;
    gap: 1rem;
  }

  :global(.bx--data-table th:last-child),
  :global(.bx--data-table td:last-child) {
    padding-right: 1rem;
    text-align: right;
  }

  :global(.bx--data-table th:last-child .bx--table-header-label) {
    display: flex;
    justify-content: flex-end;
  }

  :global(.bx--data-table td:last-child .button-secondary) {
    display: flex;
  }

  .action_cell {
    display: flex;
    justify-content: flex-end;
    gap: 0.5rem;
  }

  .blacklist_application_modal > :global(* + *) {
    margin-top: var(--control-gap);
  }

  .input_wrapper {
    display: flex;
    flex-direction: column;
    background-color: var(--pax-white);
    gap: var(--control-gap);
  }
  /* 
  :global(.modal_wrapper .bx--form-item) {
    gap: 0.45rem;
  }

  :global(.modal_wrapper .bx--label) {
    color: var(--pax-black);
    font-family: var(--font-family-inter);
    font-size: calc(var(--n) * 0.75);
    font-weight: 500;
    line-height: 1rem;
    margin: 0;
  }

  :global(.modal_wrapper .bx--text-input) {
    border: solid 1px var(--pax-black-inactive);
    border-radius: 0.5rem;
    height: 48px;
  }

  :global(.modal_wrapper .bx--text-input::placeholder) {
    color: var(--pax-black-inactive);
  }

  :global(.modal_wrapper .bx--text-input:focus) {
    outline: solid var(--bw) var(--pax-black);
    color: var(--pax-black);
  } */

  .rule_suggestions {
    display: flex;
    flex-wrap: wrap;
    gap: var(--control-gap);
    margin-top: var(--control-gap);
  }

  .rule_input_row {
    display: flex;
    align-items: flex-start;
    gap: var(--control-gap);
  }

  .rule_input_field {
    flex: 1;
    min-width: 0;
  }

  /* Aligns the button with the input, below the field label. */
  .howto_button {
    margin-top: 1.5rem;
  }

  .howto {
    display: flex;
    flex-direction: column;
    gap: var(--control-gap);
  }

  .howto_image {
    align-self: center;
    width: auto;
    max-width: 100%;
    /* Modal is capped at 84% height, 18rem covers header, step text and footer. */
    max-height: calc(84vh - 18rem);
    border: 1px solid var(--pax-black-inactive);
    border-radius: 0.5rem;
  }

  .howto_text {
    text-align: center;
  }

  .howto_text p {
    margin: 0;
  }

  .howto_step {
    font-weight: 600;
  }

  /* .modal_application {
    display: flex;
    position: fixed;
    align-items: center;
    justify-content: center;
    height: 100%;
    width: 100%;
    background-color: #f2f2f290;
    backdrop-filter: blur(4px);
    z-index: 2;
    top: 0;
    left: 0;
    opacity: 100%;
    border-radius: 2rem;
  }

  .hidden {
    opacity: 0%;
    display: none;
  }

  .modal_wrapper {
    display: flex;
    flex-direction: column;
    gap: 1rem;
    max-width: 1200px;
    padding: 3rem;
    background-color: white;
    border-radius: 2rem;
    box-shadow: 0px 0px 0.5rem #1c1c2030;
  } */
</style>
